
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/category/[category]",
      function () {
        return require("private-next-pages/blog/category/[category].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/category/[category]"])
      });
    }
  